import {Component,Input} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {FactureTypeCharge} from '@domain/facture/facture-type-charge';
import {Router} from "@angular/router";
import {TypesChargesService} from "@services/admin/facture/types-charges.service";
import {NatureVoyage} from "@domain/prestation/nature-voyage";

@Component({
    host: {'data-test-id': 'factures-types-charges-item'},
    templateUrl: './factures-types-charges-item.component.html'
})
export class FacturesTypesChargesItemComponent extends ListViewItem<FactureTypeCharge> {
    /** Liste des opérations carte */
    @Input() data: FactureTypeCharge;

    /**
     * Constructeur
     * 
     * @param router Router pour la navigation
     * @param typesChargesService Service de gestion des types de charges
     */
    constructor(private router: Router,
                public typesChargesService: TypesChargesService) {
        super();
    }

    /**
     * Navigation vers le détail du type de charge
     */
    onItemClick() {
        this.router.navigate(['/Admin/Frais/Factures/TypesCharges', this.data.idTypeCharge]);
    }

    /**
     * Retourne l'icone associée à un type de charge NatureVoyage
     * @param codeFamille Code de la famille
     * @return nom de l'icone
     */
    getIconeFromNatureVoyage(codeFamille: string): string {
        return NatureVoyage.getIcone(codeFamille as NatureVoyage);
    }
}
